// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"S4-z","colorTextValue":"T4-z","swatches":"U4-z","collapseLink":"V4-z","isCollapsed":"W4-z","dropdown":"X4-z","disabled":"Y4-z"};